<template>
    <router-view></router-view>
</template>

<script>
    // Import Vue
    import Vue from 'vue';

    // Import components
    import {TableComponent, TableColumn} from 'vue-table-component';
    import {Tabs, Tab} from 'vue-tabs-component';

    // Import global css
    import css from '@/assets/scss/global.scss';

    // Import notification
    import Notifications from 'vue-notification'
    Vue.use(Notifications)

    // Import scroll to
    import ScrollTo from 'vue-scrollto';
    Vue.use(ScrollTo)

    // Import icons
    import * as svgicon from 'vue-svgicon'
    import '@/assets/dist/icons';

    // Import FontFaceObserver for performant font rendering
    import FontFaceObserver from 'fontfaceobserver'

    // Load fonts
    const font = new FontFaceObserver('Geogrotesque');

    font.load().then(function () {
        document.querySelector('html').classList.add('fonts-loaded');
    });

    if (!!window.MSInputMethodContext && !!document.documentMode) {
        document.querySelector('html').classList.add('is-ie11');
    }

    // Register plugins
    Vue.component('table-component', TableComponent);
    Vue.component('table-column', TableColumn);
    Vue.component('tabs', Tabs);
    Vue.component('tab', Tab);
    Vue.use(svgicon, {
        tagName: 'svgicon'
    });

    export default {}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/App.vue